import {useEffect, useState} from "react";
import "../App.scss"
import "../styles/filters.scss"

export default function FilterList({filterList, tags, setTags, setCurrentPage, hiddenFilters, setHiddenFilters}) {

    const showFilter = (e) => {
        let parentClass = e.target.parentElement.className;
        if (parentClass === "filter-item active") {
            e.target.parentElement.className = "filter-item";
        } else {
            let elems = document.getElementsByClassName("filter-item");
            [].forEach.call(elems, function (el) {
                el.classList.remove("active");
            });
            e.target.parentElement.className = "filter-item active";
        }
    };

    const setFilter = async (e, filterId = "", filterName = "") => {

        let new_tag_set = Object.assign({}, tags, {[filterId]: filterName});
        // NOW DISABLE PARENTS!!!
        const element = e.target;
        element.closest(".filter-item").classList.add("disabled");

        // Prepare HIDDEN filters for coming form another page...
        const newHiddenFilters = [...hiddenFilters];
        newHiddenFilters.push(filterId);
        setHiddenFilters(newHiddenFilters);

        // On changing to NEW search, we must RESET the page-counter (from other previos results)
        setCurrentPage(0);

        // And now, we SET the chosen tags...
        setTags(new_tag_set);
    };

    // Now we TRAVERSE all main ITEMS (roots), and, if they are in hidden array, we assign "disabled" to it...
    if (filterList !== null) {
        filterList.forEach((filter) => {
            filter["enabled_disabled"] = hiddenFilters.includes(filter["uri"]) ? ' disabled' : '';
        });
    } else {
        return (
          <></>
        );
    }

    // NOW Render all !!
    if(filterList?.length === 0) {
        return (
            <p>Tots els filtres disponibles han estat aplicats, o no hi han filtres per la paraula introduïda en el cercador...</p>
        );

    } else {
        return (
            <div>
                <h2>Filtres disponibles</h2>
                <p>Aquest filtres són dinàmics i s'adapten als criteris de cerca</p>
                {(filterList?.length === hiddenFilters?.length) && <p>(tots els filtres disponibles ja estan aplicats)</p>}
                <br />
                <ul className="filters-list">
                {filterList.map((filter, i) => (
                        <li

                            className={!i ? 'filter-item active' + filter.enabled_disabled : 'filter-item' + filter.enabled_disabled}
                            id={filter.uri}
                            key={i}
                        >
                            <span onClick={(e) => showFilter(e)}>{filter.name}</span>
                            {filter.headings?.length && (
                                <ul className="filter-subgroup">
                                    {filter.headings.map((subitem, j) => (
                                        <li
                                            className="filter-subitem"
                                            id={subitem.uri}
                                            key={j}
                                            onClick={(e) => setFilter(e, filter.uri, subitem.uri)}
                                        >
                                            <span>{subitem.name} ({subitem.count})</span>
                                        </li>
                                    ))}
                                </ul>
                            )}

                        </li>
                    ))}
                </ul>
            </div>

        );
    }
}